import {useSelector} from 'react-redux'
import {Alert, Col, Row} from 'react-bootstrap'
import {connect} from '../Notes/wrapper'
import {useLabels, useIsMexico} from '../../functions'
import {DataViewer} from '../Utilities/DataViewer'
import {TermsAndConditions} from './TermsAndConditions'
import {ProcessCancelOrderButton} from './ProcessCancelOrderButton'
import ConsentToContact from '../Cart/ConsentToContact'


export const Order = () => {
    const labels = useLabels()
    const orderId = useSelector(state => state.customer.data.orderId)

    const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === 'stage-crm-frontend.s3-website.us-east-2.amazonaws.com';
    const isMX = useIsMexico();


    return <Row>
        <Row className="mt-3">
            <Alert>{labels.orderDoneTitle}</Alert>
        </Row>
        <Row>
            <Col>
                <span>{labels.orderId} <b>{orderId}</b></span>
            </Col>

        </Row>
        <Row>
            <Col>
                {!isMX && <ConsentToContact />}
                {isDevelopment && (
                    <ProcessCancelOrderButton/>
                )}
            </Col>
        </Row>
        <TermsAndConditions/>
        <DataViewer/>
    </Row>
}


export default connect(Order, 'order')
